function hideNav() {
  document.querySelector('#usa-button .country-button-mobile').setAttribute('aria-expanded', true);
  document.querySelector('.mobile-nav').style.display = 'none';
  document.querySelector('.mobile-nav--bottom').style.display = 'none';
  document.querySelector('.mobile-country-dropdown-wrapper-mobile').style.display = 'none';
  document.getElementById('backButton').style.display = 'block';
  document.getElementById('Australia-button').style.display = 'block';
  document.getElementById('Canada-button').style.display = 'block';
  document.getElementById('France-button').style.display = 'block';
  document.getElementById('Germany-button').style.display = 'block';
  document.getElementById('Indonesia-button').style.display = 'block';
  document.getElementById('Mexico-button').style.display = 'block';
  document.getElementById('Japan-button').style.display = 'block';
  document.getElementById('uk-button').style.display = 'block';
  document.getElementById('Italy-button').style.display = 'block';
  document.getElementById('Canada-button').style.display = 'block';
  document.getElementById('Spain-button').style.display = 'block';
  document.getElementById('New-Zealand-button').style.display = 'block';
}

function showNav() {
  document.querySelector('#usa-button .country-button-mobile').setAttribute('aria-expanded', false);
  document.querySelector('.mobile-nav').style.display = 'block';
  document.querySelector('.mobile-nav--bottom').style.display = 'block';
  document.querySelector('.mobile-country-dropdown-wrapper-mobile').style.display = 'block';
  document.getElementById('backButton').style.display = 'none';
  document.getElementById('Australia-button').style.display = 'none';
  document.getElementById('Canada-button').style.display = 'none';
  document.getElementById('France-button').style.display = 'none';
  document.getElementById('Germany-button').style.display = 'none';
  document.getElementById('Indonesia-button').style.display = 'none';
  document.getElementById('Mexico-button').style.display = 'none';
  document.getElementById('Japan-button').style.display = 'none';
  document.getElementById('uk-button').style.display = 'none';
  document.getElementById('Italy-button').style.display = 'none';
  document.getElementById('Spain-button').style.display = 'none';
  document.getElementById('New-Zealand-button').style.display = 'none';
}